var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiredTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34,
    stroke: "#D2D5DF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7782 40.4485C37.6039 45.8928 24.4058 32.8135 29.5995 27.3476C32.771 24.0097 29.189 20.1965 27.2057 17.3901C23.4833 12.1295 15.3147 19.3928 15.561 24.014C16.3452 38.5883 32.1099 55.8589 47.3756 54.3509C52.1501 53.8799 57.6376 45.2554 52.1588 42.1034C49.4215 40.5262 45.6602 37.4152 42.7782 40.4463M53.3643 15.5559L43.6423 25.2779M43.6423 25.2779H51.2039M43.6423 25.2779V17.7163",
    stroke: "#0F205E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiredTel);
export default __webpack_public_path__ + "static/media/tired_tel.37f77524d2b30aab98feb313e02b39b6.svg";
export { ForwardRef as ReactComponent };